// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file inventory/v1/artifact_service.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import { ArtifactService } from "./artifact_service_pb";

/**
 * @generated from rpc inventory.v1.ArtifactService.ListUserSourcedArtifact
 */
export const listUserSourcedArtifact = ArtifactService.method.listUserSourcedArtifact;

/**
 * @generated from rpc inventory.v1.ArtifactService.ListCompanyArtifact
 */
export const listCompanyArtifact = ArtifactService.method.listCompanyArtifact;
